import { FormattedMessage as FM } from "react-intl";

import ListFieldHint from "./ListFieldHint";

function ListBooleanField({ field, value, onChange }) {
  return (
    <div>
      <label className="flex min-h-11 items-center gap-3 text-sm text-neutral-800">
        <input
          type="checkbox"
          checked={value}
          onChange={(event) => onChange(field.name, event.target.checked)}
          className="size-5"
        />
        <FM id={field.label} />
      </label>
      <ListFieldHint id={field.hint} />
    </div>
  );
}

export default ListBooleanField;
